import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PayAccountDefaultIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      strokeWidth={strokeWidth}
      viewBox="0 0 24 24"
    >
      <path
        d="M11.99 13.64C15.68 13.64 18.69 10.64 18.69 6.94C18.69 3.24 15.68 0.25 11.99 0.25C8.29998 0.25 5.28998 3.25 5.28998 6.95C5.28998 10.65 8.28998 13.65 11.99 13.65V13.64ZM11.99 1.75C14.85 1.75 17.19 4.08 17.19 6.95C17.19 9.82 14.86 12.15 11.99 12.15C9.11998 12.15 6.78998 9.82 6.78998 6.95C6.78998 4.08 9.11998 1.75 11.99 1.75Z"
        fill={color}
      />
      <path
        d="M20.96 18.65C19.14 16.44 15.79 15.12 12 15.12C8.21003 15.12 4.86003 16.44 3.04003 18.65C2.27003 19.59 2.11003 20.85 2.63003 21.94C3.16003 23.06 4.27003 23.75 5.52003 23.75H18.48C19.73 23.75 20.84 23.05 21.37 21.94C21.89 20.85 21.73 19.59 20.96 18.65ZM20.01 21.3C19.73 21.9 19.15 22.25 18.48 22.25H5.52003C4.84003 22.25 4.27003 21.89 3.99003 21.3C3.72003 20.73 3.80003 20.09 4.20003 19.6C5.74003 17.73 8.65003 16.62 12 16.62C15.35 16.62 18.26 17.74 19.8 19.6C20.2 20.09 20.28 20.73 20.01 21.3Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PayAccountDefaultIcon.displayName = 'PayAccountDefaultIcon';
